module.exports = __webpack_public_path__ + "img/gaojing2.69361723.png";